/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import { SerializedLegacyAttributeFilters } from 'cio/types/conditions/legacy-filter';
import { FormTriggeredCampaignFormTriggerFilter } from 'cio/models/campaign';
import deserializeAndNormalizeFormAttributeFilters from 'cio/utils/campaigns/deserialize-normalize-form-attribute-filters';
import { tracked } from '@glimmer/tracking';
import FacebookLeadAdsForm from 'cio/models/facebook-lead-ads-form';
import { FlyActionDropdownItem } from '@customerio/fly-components/addon/components/fly-action-dropdown';
import CustomFormsService from 'cio/services/custom-forms';
import CustomForm from 'cio/models/custom-form';
import { FormType } from 'cio/utils/forms';

interface CioCampaignFormTriggerArgs {
  canSendOneTimeEvent: boolean;
  attributeFilters: SerializedLegacyAttributeFilters;
  formNamesOnly: boolean;
}

export default class CioCampaignFormTrigger extends Component<CioCampaignFormTriggerArgs> {
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;
  @tracked formForSendTestEventModal: FacebookLeadAdsForm | CustomForm | undefined;

  readonly FormType = FormType;

  constructor(owner: unknown, args: CioCampaignFormTriggerArgs) {
    super(owner, args);

    this.facebookLeadAds.initialize();
    this.customForms.initialize();
  }

  get normalizedFilters() {
    return deserializeAndNormalizeFormAttributeFilters(this.args.attributeFilters);
  }

  @computed('facebookLeadAds.forms.[]', 'customForms.forms.[]')
  get formsForDisplay() {
    return this.normalizedFilters.children.map((c: FormTriggeredCampaignFormTriggerFilter) => {
      let [{ formType, value: id }] = c.children;
      let [, dataFilters] = c.children;

      let form: CustomForm | FacebookLeadAdsForm | undefined;
      let defaultTitle: string;

      if (formType === FormType.FacebookLeadAds) {
        form = this.facebookLeadAds.forms.findBy('formId', id);
        defaultTitle = `Facebook Lead Ads form with Facebook Form ID of ${id}`;
      } else {
        form = this.customForms.forms.findBy('formIdLowercase', id);
        defaultTitle = formType === FormType.Typeform ? `Typeform with ID of ${id}` : `Custom form with ID of ${id}`;
      }

      return {
        form,
        formType,
        name: form?.name ?? defaultTitle,
        dataFilters,
      };
    });
  }

  @computed('formsForDisplay.@each.{name,form}')
  get testFormEventDropdownItems(): FlyActionDropdownItem[] {
    let items: FlyActionDropdownItem[] = this.formsForDisplay.map((f) => ({
      label: f.name,
      action: () => (this.formForSendTestEventModal = f.form),
    }));

    return items;
  }
}
